module.exports = __webpack_public_path__ + "static/media/researchgate-logo.45617690.png";